import script from "./ReactivationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactivationModal.vue?vue&type=script&setup=true&lang=js"

import "./ReactivationModal.vue?vue&type=style&index=0&id=8d0b109a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d0b109a"]])

export default __exports__